module.exports = __webpack_public_path__ + "img/lcd_02.99a31289.jpg";